
export default {
  head() {
    return {
      script: [
        {
          src: '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js', type: 'text/javascript', async: true, defer: true, external: true
        }
      ]
    }
  },
  mounted() {
    Trustpilot?.loadFromElement(this.$el.querySelector('.trustpilot-widget'))
  }
}
